import { Link } from 'react-router-dom';
import { Badge } from '../ui';
import type { BadgeTone } from '../ui';
import { AI_JOB_STATUS_LABEL } from '../../lib/aiJobLabels';
import type { AiJob } from '../../lib/aiJobs';

/** A site's open agent job (hosting fix by default, or setup), linked to it in the agent queue. */
export default function OpenFixBadge({ job, label = 'Fix', tone = 'warn', title = 'Hosting fix in the agent queue' }: { job: AiJob | undefined; label?: string; tone?: BadgeTone; title?: string }) {
  if (!job) return null;
  return (
    <Link to={`/agents?job=${job.id}`} onClick={(e) => e.stopPropagation()} title={title} style={{ display: 'inline-flex', textDecoration: 'none' }}>
      <Badge tone={tone} dot>
        {label}: {AI_JOB_STATUS_LABEL[job.status]}
      </Badge>
    </Link>
  );
}
